import { RESET_DATASET } from 'store';

import { SET_SELECTED_SAMPLE_ID } from './types';
import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = 0, action) => {
  switch (action.type) {
    case SET_SELECTED_SAMPLE_ID:
      return action.selectedSampleId;

    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return 0;

    default:
      return state;
  }
};
